function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}
function cartFooter() {
  const cartFooterHeight =
    document.querySelector('.drawer__footer').offsetHeight;
  return cartFooterHeight;
}
function announcementHeight() {
  if (document.body.contains(document.querySelector('.announcement-bar'))) {
    const announcementHeight =
      document.querySelector('.announcement-bar').offsetHeight;
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);
document.documentElement.style.setProperty(
  '--cart-footer-height',
  cartFooter() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);

window.addEventListener('resize', debounce(function() {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--cart-footer-height',
      cartFooter() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );
  }, 50)
);

const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  function fixHeader() {
    const stickyOffset = siteHeader.offsetHeight;
    const scroll = window.scrollY;

    if (scroll > stickyOffset) {
      if (!siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.add('scrolling');
        siteHeader.classList.add('fixed');
      }
    } else {
      if (siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.remove('scrolling');
        siteHeader.classList.remove('fixed');
      }
    }
  }

  window.addEventListener(
    'touchmove',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'scroll',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'resize',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener('load', (event) => {
    fixHeader();
  });
}


/************ Smooth Scroll  ****************/

document.querySelectorAll('a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])').forEach((anchor) => {   
  anchor.addEventListener('click', function(e){
     e.preventDefault();
        console.log('scroll to ', e);
        const offset = headerHeight() * -2;
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        let target = anchor.hash;
        target = target.length ? target : document.querySelector(`[name="${this.hash.slice(1)}"]`);

      
      
        if (target.length) {   
         const element = document.getElementById(target.replace('#',''));
         console.log('element', element)
           window.scrollTo({
              top: getOffsetTop(element) + offset,
              left: 0,
              behavior: 'smooth'
            });
     
         }

        }  
  });
}); 

function getOffsetTop(element) {
 return element ? (element.offsetTop + getOffsetTop(element.offsetParent)) : 0;
}



// URL PARAMETERS
function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
} 

// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}


const animations = document.querySelectorAll('[data-trigger-animation]'); 
startAnimations(animations)



document.addEventListener('loadRecommended', (event)=> {
  console.log('Custom event triggered:', event);
  const animations = document.querySelectorAll('[data-trigger-animation]'); 
  startAnimations(animations);
});



function startAnimations(animations) { 
animations.forEach((animation) => { 
  if(isInViewport(animation)) {
    animateElement = animation.querySelectorAll('.animate-me');
    animateElement.forEach((element) => {
        element.classList.add('animate');
        element.classList.remove('animate-me');
    });
  } 
  window.addEventListener(
    'scroll',
    debounce(function () {
      console.log(isInViewport(animation), 'IS THIS IN VIEWPORT?');
      if(isInViewport(animation)) {
        animateElement = animation.querySelectorAll('.animate-me');
        animateElement.forEach((element) => {
            element.classList.add('animate');
            element.classList.remove('animate-me');
        });
      }
    }, 50)
  ); 
});
}


function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
 
/*
const activateSuccess = document.querySelectorAll('contact-success'); 
activateSuccess.forEach((success) => {
  const successModal = success.querySelector('[data-modal-target]'); 
  modalPop(successModal);
});
*/


const contactSubmit = document.querySelectorAll('[data-contact-submit]'); 
contactSubmit.forEach((submitBtn) => {
  console.log('SUBMIT BUTTON', submitBtn);
  submitBtn.addEventListener('click', setContactType);
});

function setContactType(event) {
  const type = event.target.dataset.contactSubmit;
  localStorage.setItem('contact_type', type); 
}